var star3 = "/static/e0a34e7e96fc45cd.png";

export { star3 as default };
//# sourceMappingURL=star-3.png.js.map
